import React, { useContext } from 'react';
import { Box, Button, ButtonBase, Link, Typography } from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { UserContext } from '../MiniDrawer';
import { GREEN, GREEN_DARK, GREEN_SOFT, MUTED } from './homeTheme';

/**
 * Invito in cima alla Home classica: un clic attiva il nuovo design (lo stesso interruttore "New pages" del menu utente).
 * Compare solo se ci sono pagine V2 attive, l'utente non le usa già e non ha scelto "Not now" negli ultimi 30 giorni.
 */
export function NewDesignBanner() {
  const { preferences } = useContext(UserContext);
  if (!preferences?.v2Available || preferences.v2Pages || preferences.bannerSnoozed) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 2,
        pr: 1,
        borderRadius: 3,
        border: `1px solid ${GREEN}`,
        bgcolor: GREEN_SOFT,
        overflow: 'hidden',
      }}
    >
      <ButtonBase
        onClick={preferences.toggleV2Pages}
        sx={{
          flex: 1,
          minWidth: 0,
          justifyContent: 'flex-start',
          gap: 1.5,
          px: 2,
          py: 1.25,
          textAlign: 'left',
          '&:hover .invite-title': { textDecoration: 'underline' },
        }}
      >
        <Box sx={{ width: 34, height: 34, borderRadius: '50%', bgcolor: GREEN, color: '#fff', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
          <AutoAwesomeIcon fontSize="small" />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography className="invite-title" sx={{ fontWeight: 700, color: GREEN_DARK, lineHeight: 1.3 }}>
            Click here to try the new design
          </Typography>
          <Typography sx={{ fontSize: 13, color: MUTED, lineHeight: 1.3 }}>
            Clearer pages, dark mode and quicker navigation. You can switch back at any time.
          </Typography>
        </Box>
        <ChevronRightIcon sx={{ color: GREEN_DARK, ml: 'auto', flexShrink: 0 }} />
      </ButtonBase>
      <Button color="inherit" size="small" onClick={preferences.snoozeBanner} sx={{ textTransform: 'none', color: MUTED, flexShrink: 0 }}>
        Not now
      </Button>
    </Box>
  );
}

/** Nota in fondo alla Home V2: come tornare al design classico (interruttore "New pages" nel menu utente), con il link diretto. */
export function ClassicDesignNote() {
  const { preferences } = useContext(UserContext);
  if (!preferences?.v2Available || !preferences.v2Pages) return null;

  return (
    <Typography variant="body2" sx={{ color: MUTED, textAlign: 'center', mt: 3 }}>
      Prefer the classic design? Click your name at the bottom left and turn off <strong>New pages</strong>, or{' '}
      <Link component="button" variant="body2" onClick={preferences.toggleV2Pages} underline="hover" sx={{ color: GREEN_DARK, fontWeight: 600, verticalAlign: 'baseline' }}>
        switch back now
      </Link>
      .
    </Typography>
  );
}
